<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <m-edit-text
                :label="text"
                :value="value"
                read_only
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,

            title: null,
            text: null,
            value: null,
        }
    },

    created () {
        this.$event_bus.$on('copy_dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('copy_dialog',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            this.title = params.title;
            this.text = params.text;
            this.value = params.value;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>